/**
 * COMPONENTE COTIZACIONES WIDGET
 * ==============================
 * Widget de cotizaciones de monedas para el sidebar
 */

import React from 'react';
import { Card, CardContent } from '../../ui/card';

const CotizacionesWidget = ({ cotizacionesData }) => {
    if (!cotizacionesData) return null;

    const quotes = [
        {
            name: 'Dólar USA',
            compra: cotizacionesData.Dolar_USA_Compra,
            venta: cotizacionesData.Dolar_USA_Venta,
            color: '#10b981',
            flag: 'https://flagcdn.com/w40/us.png'
        },
        {
            name: 'Euro',
            compra: cotizacionesData.Euro_Compra,
            venta: cotizacionesData.Euro_Venta,
            color: '#3b82f6',
            flag: 'https://flagcdn.com/w40/eu.png'
        },
        {
            name: 'Peso ARG',
            compra: cotizacionesData.Peso_Argentino_Compra,
            venta: cotizacionesData.Peso_Argentino_Venta,
            color: '#f59e0b',
            flag: 'https://flagcdn.com/w40/ar.png'
        },
        {
            name: 'Real BRA',
            compra: cotizacionesData.Real_Compra,
            venta: cotizacionesData.Real_Venta,
            color: '#10b981',
            flag: 'https://flagcdn.com/w40/br.png'
        },
    ];

    return (
        <Card className="border-0 shadow-lg">
            <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Cotizaciones</h3>
                <p className="text-xs text-gray-500 mb-4">
                    Última actualización: {cotizacionesData.Fecha} {cotizacionesData.Hora_de_publicacion}
                </p>

                <div className="space-y-4">
                    {quotes.map((quote, index) => (
                        <div key={index} className="flex items-center space-x-3 p-3 rounded-xl hover:bg-gray-50 transition-colors">
                            <img
                                src={quote.flag}
                                alt={quote.name}
                                className="w-8 h-8 rounded-full flex-shrink-0 shadow-lg"
                            />
                            <div className="flex-1">
                                <div className="text-sm font-bold text-gray-900">{quote.name}</div>
                                <div className="flex items-baseline space-x-2">
                                    <span className="text-xs text-gray-500">Compra:</span>
                                    <span className="text-sm font-bold text-gray-900">{quote.compra}</span>
                                    <span className="text-xs text-gray-500">| Venta:</span>
                                    <span className="text-sm font-bold text-gray-900">{quote.venta}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="mt-4 text-xs text-gray-500 text-center">Fuente: INE - BROU</p>
            </CardContent>
        </Card>
    );
};

export default CotizacionesWidget;
